/* eslint-disable react/no-unused-state */
import React from 'react';
import { Result, Button } from 'antd';

/**
 * Error Boundary component to catch React errors and display user-friendly error messages
 * Prevents the entire app from crashing when an error occurs
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }
  
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }
  
  componentDidCatch(error, errorInfo) {
    // Log error to error reporting service
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ 
      error, 
      errorInfo 
    });
    
    // TODO: Send to error tracking service (e.g., Sentry, LogRocket)
    // Example:
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, { contexts: { react: errorInfo } });
    // }
  }
  
  handleReload = () => {
    window.location.reload();
  };
  
  handleReset = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null 
    });
  };
  
  render() {
    if (this.state.hasError) {
      // Custom error UI
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle={
            <span style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.75 }}>
              An unexpected error occurred. Please try reloading the page.
              <br />
              If the problem keeps happening, our support team is here to help.
            </span>
          }
          extra={
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button type="primary" size="large" onClick={this.handleReload}>
                Reload Page
              </Button>
              <Button size="large" onClick={this.handleReset}>
                Try Again
              </Button>
              <Button
                size="large"
                style={{ fontWeight: 600, borderColor: '#1890ff', color: '#1890ff' }}
                href="/contact-us"
              >
                Contact Support
              </Button>
            </div>
          }
        />
      );
    }
    
    return this.props.children;
  }
}

export default ErrorBoundary;
